import { render, staticRenderFns } from "./CourseHandoutBlank.vue?vue&type=template&id=89c2f9c4&"
import script from "./CourseHandoutBlank.vue?vue&type=script&lang=js&"
export * from "./CourseHandoutBlank.vue?vue&type=script&lang=js&"
import style0 from "./CourseHandoutBlank.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports